import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DesktopOutlinedSvg from "@ant-design/icons-svg/es/asn/DesktopOutlined";
import AntdIcon from "../components/AntdIcon";
var DesktopOutlined = function DesktopOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DesktopOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DesktopOutlined.displayName = 'DesktopOutlined';
}
export default /*#__PURE__*/React.forwardRef(DesktopOutlined);